import React, { Fragment, useRef, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import {
	ListItemIcon,
	ListItemText,
	Tooltip,
	IconButton,
	Menu,
	MenuItem,
} from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PrintIcon from '@mui/icons-material/Print';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AchiveIcon from '@mui/icons-material/ArchiveOutlined';

const useStyles = makeStyles(() => ({}));

const OptionsButton = (props) => {
	const { exportPdf, fullScreen } = props;
	const classes = useStyles();
	const moreRef = useRef(null);
	const [openMenu, setOpenMenu] = useState(false);
	const dispatch = useDispatch();

	const handleMenuOpen = () => {
		setOpenMenu(true);
	};

	const handleMenuClose = () => {
		setOpenMenu(false);
	};

	const _exportPdf = () => {
		setOpenMenu(false);
		exportPdf();
	};

	const _fullScreen = () => {
		setOpenMenu(false);
		fullScreen();
	};

	return (
		<>
			<Tooltip title="More options">
				<IconButton
					{...props}
					onClick={handleMenuOpen}
					ref={moreRef}
					size="small"
				>
					<MoreIcon />
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={moreRef.current}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				classes={{ paper: classes.menu }}
				onClose={handleMenuClose}
				open={openMenu}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				{exportPdf && (
					<MenuItem onClick={_exportPdf}>
						<ListItemIcon>
							<PictureAsPdfIcon />
						</ListItemIcon>
						<ListItemText primary="Export as PDF" />
					</MenuItem>
				)}
				<MenuItem onClick={_fullScreen}>
					<ListItemIcon>
						<FullscreenIcon />
					</ListItemIcon>
					<ListItemText primary="View Fullscreen" />
				</MenuItem>
			</Menu>
		</>
	);
};

OptionsButton.propTypes = {
	className: PropTypes.string,
	exportPdf: PropTypes.func,
	fullScreen: PropTypes.func
};

export default memo(OptionsButton);
